'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import { ELanguage } from '../Utils/constants.js';
import { getCookie } from '../Utils/cookie.js';
import { objToQueryStr } from '../Utils/urlBuilder.js';

function changeJobTitle(_a) {
    var baseUrl = _a.baseUrl, accessToken = _a.accessToken, langCode = _a.langCode, value = _a.value;
    return __awaiter(this, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/api-gateway/v1.0/profile/job-title"), {
                            method: 'PUT',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            },
                            body: JSON.stringify({
                                jobTitle: value
                            })
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    err_1 = _b.sent();
                    console.error(err_1);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function changePhoneNumber(_a) {
    var baseUrl = _a.baseUrl, accessToken = _a.accessToken, langCode = _a.langCode, value = _a.value;
    return __awaiter(this, void 0, void 0, function () {
        var response, err_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/api-gateway/v1.0/profile/change-phone"), {
                            method: 'PUT',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            },
                            body: JSON.stringify({
                                phone: value
                            })
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    err_2 = _b.sent();
                    console.error(err_2);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var uploadFile = function (_a) {
    var accessToken = _a.accessToken, langCode = _a.langCode, baseUrl = _a.baseUrl, file = _a.file;
    return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    formData = new FormData();
                    formData.append('resume_file', file);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/api-gateway/v1.0/profile/update-resume-file"), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept-Language': langCode
                            },
                            body: formData
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    error_1 = _b.sent();
                    console.error('apiDoUpload ', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
};
var validateFile = function (_a) {
    var accessToken = _a.accessToken, langCode = _a.langCode, baseUrl = _a.baseUrl, file = _a.file, userId = _a.userId, jobId = _a.jobId;
    return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, data, error_2, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    formData = new FormData();
                    formData.append('file', file);
                    formData.append('jobId', jobId ? String(jobId) : '0');
                    formData.append('jobseekerId', userId ? String(userId) : '0');
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/attached-resumes-validation/v1/validate-resume"), {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept-Language': langCode
                            },
                            body: formData
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _b.sent();
                    return [2 /*return*/, data];
                case 3:
                    error_2 = _b.sent();
                    console.error('apiDoValidate ', error_2);
                    data = {
                        meta: {
                            statusCode: 413,
                            message: langCode === ELanguage.VI
                                ? 'Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB'
                                : '.doc, .docx and .pdf files that are less than 5120KB in size'
                        }
                    };
                    return [2 /*return*/, data];
                case 4: return [2 /*return*/];
            }
        });
    });
};
var getInfoWhenApplyOneClick = function (_a) {
    var jobid = _a.jobid, baseUrl = _a.baseUrl, langCode = _a.langCode;
    return __awaiter(void 0, void 0, void 0, function () {
        var body, response, data, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    body = {
                        action: 'loadApplyForm',
                        jobid: String(jobid)
                    };
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/jobseekers/apply_on_oneclick.php"), {
                            method: 'POST',
                            headers: {
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept-Language': langCode,
                                'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                                'x-requested-with': 'XMLHttpRequest'
                            },
                            body: objToQueryStr(body)
                        })];
                case 1:
                    response = _b.sent();
                    if (!response) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _b.sent();
                    return [2 /*return*/, __assign(__assign({}, data), { resumes: JSON.parse(data === null || data === void 0 ? void 0 : data.resumes) })];
                case 3: return [2 /*return*/, null];
                case 4:
                    error_3 = _b.sent();
                    console.error(error_3);
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    });
};
var applyJobs = function (params, baseUrl, langCode) { return __awaiter(void 0, void 0, void 0, function () {
    var formData, VNW_TRACKING_GA, VNW_TRACKING_GA_FIRST, utmGA, utmGAFirst, newParams, _i, _a, _b, key, value, _c, _d, _e, key, value, response, data, error_4, data;
    var _f, _g;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                formData = new FormData();
                VNW_TRACKING_GA = (_f = getCookie('VNW_TRACKING_GA')) !== null && _f !== void 0 ? _f : '';
                VNW_TRACKING_GA_FIRST = (_g = getCookie('VNW_TRACKING_GA_FIRST')) !== null && _g !== void 0 ? _g : '';
                utmGA = JSON.parse(decodeURIComponent(VNW_TRACKING_GA));
                utmGAFirst = JSON.parse(decodeURIComponent(VNW_TRACKING_GA_FIRST));
                newParams = __assign(__assign({}, params), utmGA);
                for (_i = 0, _a = Object.entries(newParams); _i < _a.length; _i++) {
                    _b = _a[_i], key = _b[0], value = _b[1];
                    if (key && value) {
                        if (key.startsWith('utm')) {
                            formData.append("utms[".concat(key, "]"), value);
                        }
                        else {
                            formData.append(key, value);
                        }
                    }
                }
                for (_c = 0, _d = Object.entries(utmGAFirst); _c < _d.length; _c++) {
                    _e = _d[_c], key = _e[0], value = _e[1];
                    if (key && value) {
                        formData.append("utms[".concat(key, "_first]"), value);
                    }
                }
                _h.label = 1;
            case 1:
                _h.trys.push([1, 5, , 6]);
                return [4 /*yield*/, fetch("".concat(baseUrl, "/jobseekers/apply_on_oneclick.php"), {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept-Language': langCode
                        },
                        body: formData
                    })];
            case 2:
                response = _h.sent();
                if (!response) return [3 /*break*/, 4];
                return [4 /*yield*/, response.json()];
            case 3:
                data = _h.sent();
                return [2 /*return*/, data];
            case 4: return [2 /*return*/];
            case 5:
                error_4 = _h.sent();
                if (error_4.message === 'Timeout' ||
                    error_4.message === 'Network request failed' ||
                    error_4.message === 'Failed to fetch') {
                    data = {
                        status: 'ERROR',
                        message: langCode === ELanguage.EN
                            ? 'No internet connection. Please check your internet connection and try again.'
                            : 'Không có kết nối Internet. Vui lòng kiểm tra kết nối internet của bạn và thử lại.'
                    };
                    return [2 /*return*/, data];
                }
                console.error(error_4);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); };
function getProfileLevel(accessToken, langCode, baseUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/api-gateway/v1.0/profile/level"), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
                case 3:
                    err_3 = _a.sent();
                    console.error(err_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getResumeSettingInfo(accessToken, langCode, baseUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/api-gateway/v1.1/profile/resume-setting-info?date=").concat(Date.now()), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
                case 3:
                    err_4 = _a.sent();
                    console.error(err_4);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var getJobLevelList = function (langCode, baseMsUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var response, dataJs, relationships, err_5;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(baseMsUrl, "/meta/v1.0/job-levels"), {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode
                        }
                    })];
            case 1:
                response = _c.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                dataJs = _c.sent();
                relationships = (_a = dataJs === null || dataJs === void 0 ? void 0 : dataJs.data) === null || _a === void 0 ? void 0 : _a.relationships;
                if ((relationships === null || relationships === void 0 ? void 0 : relationships.data) && ((_b = relationships === null || relationships === void 0 ? void 0 : relationships.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    return [2 /*return*/, relationships.data];
                }
                return [2 /*return*/, null];
            case 3:
                err_5 = _c.sent();
                console.error(err_5);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
function getPrivacyPolicy(params) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var langCode, body, _d, accessToken, _e, baseUrl, URL_1, res, responseData, ex_1;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 3, , 4]);
                    langCode = params.langCode, body = params.body, _d = params.accessToken, accessToken = _d === void 0 ? '' : _d, _e = params.baseUrl, baseUrl = _e === void 0 ? '' : _e;
                    if (accessToken === '') {
                        return [2 /*return*/, []];
                    }
                    if (baseUrl === '') {
                        return [2 /*return*/, []];
                    }
                    URL_1 = "".concat(baseUrl, "/api-gateway/v1.0/job/policies");
                    return [4 /*yield*/, fetch(URL_1, {
                            method: 'POST',
                            body: JSON.stringify(body),
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: 'application/json',
                                Authorization: "Bearer ".concat(accessToken),
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    res = _f.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    responseData = _f.sent();
                    if ((_a = responseData === null || responseData === void 0 ? void 0 : responseData.data) === null || _a === void 0 ? void 0 : _a.jobPolicies) {
                        return [2 /*return*/, (_c = (_b = responseData.data) === null || _b === void 0 ? void 0 : _b.jobPolicies) !== null && _c !== void 0 ? _c : []];
                    }
                    return [2 /*return*/, []];
                case 3:
                    ex_1 = _f.sent();
                    console.error(ex_1);
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    });
}

export { applyJobs, changeJobTitle, changePhoneNumber, getInfoWhenApplyOneClick, getJobLevelList, getPrivacyPolicy, getProfileLevel, getResumeSettingInfo, uploadFile, validateFile };
//# sourceMappingURL=service.js.map
